import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import styles from './CollageWorks.module.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const CollageWorks = () => {
  const [activeImage, setActiveImage] = useState(null);

  const collageImages = [
    {
      id: 1,
      src: '/assets/images/db.jpg',
      alt: 'DB',
      category: 'Branding'
    },
    {
      id: 2,
      src: '/assets/images/ritt.jpg',
      alt: 'Rit alumni',
      category: 'Design'
    },
    {
      id: 3,
      src: '/assets/images/art.jpg',
      alt: 'art nflok',
      category: 'Creative'
    },
    {
      id: 4,
      src: '/assets/images/cir.jpg',
      alt: 'Belle Bakery',
      category: 'Advertising'
    },
    {
      id: 5,
      src: '/assets/images/belle.jpg',
      alt: 'Belle',
      category: 'Branding'
    },
    {
      id: 6,
      src: '/assets/images/bledi.jpg',
      alt: 'Bledi',
      category: 'Design'
    },
    {
      id: 7,
      src: '/assets/images/nevri.jpg',
      alt: 'shehollkat',
      category: 'Creative'
    },
    {
      id: 8,
      src: '/assets/images/padel.jpg',
      alt: 'Padel Arena',
      category: 'Branding'
    },
    {
      id: 9,
      src: '/assets/images/gd.jpg',
      alt: 'Goddess',
      category: 'Design'
    },
    {
      id: 10,
      src: '/assets/images/nas.jpg',
      alt: 'Flynas',
      category: 'Creative'
    },
    {
      id: 11,
      src: '/assets/images/euro.jpg',
      alt: 'EUROMED',
      category: 'Branding'
    },
    {
      id: 12,
      src: '/assets/images/flyy.png',
      alt: 'flynas',
      category: 'Design'
    },
    {
      id: 13,
      src: '/assets/images/rit.jpg',
      alt: 'RIT',
      category: 'Creative'
    },
    {
      id: 14,
      src: '/assets/images/car.jpg',
      alt: 'Brendimi i Makinave',
      category: 'Automotive'
    },
    {
      id: 15,
      src: '/assets/images/banner.webp',
      alt: 'Billboard Design',
      category: 'Advertising'
    },
    {
      id: 16,
      src: '/assets/images/totem.webp',
      alt: 'Totem 3D',
      category: '3D Branding'
    },
    {
      id: 17,
      src: '/assets/images/inside.webp',
      alt: 'Brendimi 3D',
      category: '3D Branding'
    },
    {
      id: 18,
      src: '/assets/images/menu.webp',
      alt: 'Materiale të Personalizuara',
      category: 'Print Design'
    }
  ];

  return (
    <section className={styles.collageSection}>
      <div className={styles.collageContainer}>
        <div className={styles.sectionHeader}>
          <h2>Punimet Tona</h2>
          <span>OUR WORKS</span>
          <p>
            Eksploroni koleksionin tonë të punimeve të ndryshme, nga eventet e mëdha deri te portretet intime. 
            Çdo projekt është një histori unike që tregon kreativitetin dhe profesionizmin tonë.
          </p>
        </div>

        {/* Desktop Grid Layout */}
        <div className={styles.desktopGrid}>
          {collageImages.map((image, index) => (
            <div 
              key={image.id} 
              className={`${styles.gridItem} ${styles[`item${index + 1}`]}`}
              onClick={() => setActiveImage(index)}
            >
              <div className={styles.imageWrapper}>
                <img 
                  src={image.src} 
                  alt={image.alt} 
                  loading="lazy"
                  decoding="async"
                />
                <div className={styles.overlay}>
                  <div className={styles.category}>{image.category}</div>
                  <div className={styles.zoomIcon}>+</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Swiper */}
        <div className={styles.mobileSwiper}>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1.2}
            navigation={false}
            pagination={{ 
              clickable: true,
              bulletClass: styles.swiperPaginationBullet,
              bulletActiveClass: styles.swiperPaginationBulletActive
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={800}
            breakpoints={{
              480: {
                slidesPerView: 1.5,
                spaceBetween: 25,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 30,
              }
            }}
          >
            {collageImages.map((image) => (
              <SwiperSlide key={image.id}>
                <div className={styles.swiperSlide}>
                  <div className={styles.imageWrapper}>
                    <img 
                      src={image.src} 
                      alt={image.alt}
                      loading="lazy"
                      decoding="async"
                    />
                    <div className={styles.overlay}>
                      <div className={styles.category}>{image.category}</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Modal for Desktop */}
        {activeImage !== null && (
          <div className={styles.modal} onClick={() => setActiveImage(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.closeBtn} onClick={() => setActiveImage(null)}>×</button>
              <img 
                src={collageImages[activeImage].src} 
                alt={collageImages[activeImage].alt}
                loading="eager"
              />
              <div className={styles.modalInfo}>
                <h3>{collageImages[activeImage].alt}</h3>
                <p>{collageImages[activeImage].category}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CollageWorks;
